import CrudService from "@/services/shared/http/CrudService"

export default class HelpService extends CrudService {
    constructor(params= {}) {
        super('feedback', params)
    }
}
